import ApologyModel from '../Apis/Apology'
import Controller from './Controller'

export default class ApologyController extends Controller {
  constructor() {
    super(new ApologyModel())
  }
}
